import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=703165f8"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703165f8')) {
      api.createRecord('703165f8', component.options)
    } else {
      api.reload('703165f8', component.options)
    }
    module.hot.accept("./Archive.vue?vue&type=template&id=703165f8", function () {
      api.rerender('703165f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/plot/Archive.vue"
export default component.exports